<template>
    <div v-if="loginState.isAuditor">
        <b-card>
            <div slot="header">
                {{benefitVehicle.registrationNumber ? "Edit fordon" : "Nytt fordon"}}
                <div class="card-header-actions">
                <b-spinner v-if="loading" class="mr-1" type="border" small />
                </div>
            </div>
            <b-tabs>
                <b-tab active>
                    <template slot="title">
                        <span :class="{'text-danger': $v.validationGroup_Information.$anyError }">Information</span>
                    </template>
                    <b-form-checkbox v-model="benefitVehicle.isActive" class="mb-1">
                        Aktiv
                    </b-form-checkbox>
                    <b-form-group>
                        <label>Brukare</label>
                        <br />
                        <b-dropdown :class="{ 'dropdownError': $v.benefitVehicle.employeeId.$anyError }" :text="!benefitVehicle.employeeId ? 'Välj brukare' : getEmployeeName(benefitVehicle.employeeId)">
                            <b-dropdown-item v-for="employee in employees" :key="employee.id" v-on:click="employeeSelected(employee)">{{employee.firstName + " " + employee.lastName}}</b-dropdown-item>
                        </b-dropdown>
                        <b-form-invalid-feedback :state="!$v.benefitVehicle.employeeId.$anyError">
                            Detta fält är obligatoriskt
                        </b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-group>
                        <label>Fordonstyp</label>
                        <br />
                        <b-dropdown :class="{ 'dropdownError': $v.benefitVehicle.vehicleType.$anyError }" :text="!benefitVehicle.vehicleType ? 'Välj fordonstyp' : getVehicleTypeName(benefitVehicle.vehicleType)">
                            <b-dropdown-item v-for="vehicleType in vehicleTypes" :key="vehicleType.id" v-on:click="vehicleTypeSelected(vehicleType)">{{vehicleType.name}}</b-dropdown-item>
                        </b-dropdown>
                        <b-form-invalid-feedback :state="!$v.benefitVehicle.vehicleType.$anyError">
                            Detta fält är obligatoriskt
                        </b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-group>
                        <label for="registrationNumber">Registreringsnummer
                        </label>
                        <b-form-input type="text" id="registrationNumber"
                            v-model.trim="$v.benefitVehicle.registrationNumber.$model"
                            class="col-lg-2 col-md-6 col-sm-9 col-12"
                            :class="{ 'is-invalid': $v.benefitVehicle.registrationNumber.$anyError}">
                        </b-form-input>
                        <b-form-invalid-feedback>
                            Detta fält är obligatoriskt
                        </b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-group>
                        <label for="modelCode">Modellkod
                        </label>
                        <b-form-input type="text" id="modelCode"
                            v-on:blur="showAutofillDialogue"
                            v-model.trim="$v.benefitVehicle.modelCode.$model"
                            :formatter="formatToUpperCase"
                            class="col-lg-2 col-md-6 col-sm-9 col-12 uppercase"
                            :class="{ 'is-invalid': $v.benefitVehicle.modelCode.$anyError}">
                        </b-form-input>
                        <b-form-invalid-feedback>
                            Detta fält är obligatoriskt
                        </b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-group>
                        <label for="brand">Märke
                        </label>
                        <b-form-input type="text" id="brand"
                            v-model.trim="$v.benefitVehicle.brand.$model"
                            class="col-lg-2 col-md-6 col-sm-9 col-12"
                            :class="{ 'is-invalid': $v.benefitVehicle.brand.$anyError}">
                        </b-form-input>
                        <b-form-invalid-feedback>
                            Detta fält är obligatoriskt
                        </b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-group>
                        <label for="model">Modell
                        </label>
                        <b-form-input type="text" id="model"
                            v-model.trim="$v.benefitVehicle.model.$model"
                            class="col-lg-2 col-md-6 col-sm-9 col-12"
                            :class="{ 'is-invalid': $v.benefitVehicle.model.$anyError}">
                        </b-form-input>
                        <b-form-invalid-feedback>
                            Detta fält är obligatoriskt
                        </b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-group>
                        <label for="productionYear">Tillverkningsår
                        </label>
                        <b-form-input type="text" id="productionYear"
                            v-model.number="$v.benefitVehicle.productionYear.$model"
                            class="col-lg-1 col-md-3 col-sm-9 col-12"
                            :class="{ 'is-invalid': $v.benefitVehicle.productionYear.$anyError}">
                        </b-form-input>
                        <b-form-invalid-feedback>
                            Ogiltigt eller saknat obligatoriskt värde
                        </b-form-invalid-feedback> 
                    </b-form-group>
                    <b-form-group>
                        <label>Bränsletyp</label>
                        <br />
                        <b-dropdown :class="{ 'dropdownError': $v.benefitVehicle.fuelType.$anyError }" :text="!benefitVehicle.fuelType ? 'Välj fordonstyp' : getFuelTypeName(benefitVehicle.fuelType)">
                            <b-dropdown-item v-for="fuelType in fuelTypes" :key="fuelType.id" v-on:click="fuelTypeSelected(fuelType)">{{fuelType.name}}</b-dropdown-item>
                        </b-dropdown>
                        <b-form-invalid-feedback :state="!$v.benefitVehicle.fuelType.$anyError">
                            Detta fält är obligatoriskt
                        </b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-group>
                        <label for="price">Nybilspris
                        </label>
                        <b-form-input type="text" id="price"
                            v-model.number="$v.benefitVehicle.price.$model"
                            class="col-lg-1 col-md-3 col-sm-9 col-12"
                            :class="{ 'is-invalid': $v.benefitVehicle.price.$anyError}">
                        </b-form-input>
                        <b-form-invalid-feedback>
                            Ogiltigt eller saknat obligatoriskt värde
                        </b-form-invalid-feedback> 
                    </b-form-group>
                    <b-form-group>
                        <label for="adjustmentPrice">Justering
                        </label>
                        <b-form-input type="text" id="adjustmentPrice"
                            v-model.number="$v.benefitVehicle.adjustmentPrice.$model"
                            class="col-lg-1 col-md-3 col-sm-9 col-12"
                            :class="{ 'is-invalid': $v.benefitVehicle.adjustmentPrice.$anyError}">
                        </b-form-input>
                        <b-form-invalid-feedback>
                            Ogiltigt eller saknat obligatoriskt värde
                        </b-form-invalid-feedback> 
                    </b-form-group>
                </b-tab>
                <b-tab>
                    <template slot="title">
                        <span :class="{'text-danger': $v.validationGroup_Benefits.$anyError }">Förmånsvärden</span>
                    </template>
                    <b-card>
                        <div slot="header">
                            Nedsättning av bilförmånsvärde
                        </div>
                        <b-form-checkbox v-model="benefitCalculationValues.distanceOverThreeThousand" class="mb-1">
                            3000 mil eller mer/kalenderår i tjänsten
                        </b-form-checkbox>
                    </b-card>
                    <b-form-group>
                        <label for="vehicleTax">Fordonsskatt
                        </label>
                        <b-form-input type="text" id="vehicleTax"
                            v-model.number="$v.benefitCalculationValues.vehicleTax.$model"
                            class="col-lg-2 col-md-3 col-sm-9 col-12"
                            :class="{ 'is-invalid': $v.benefitCalculationValues.vehicleTax.$anyError}">
                        </b-form-input>
                        <b-form-invalid-feedback>
                            Ogiltigt eller saknat obligatoriskt värde
                        </b-form-invalid-feedback> 
                    </b-form-group>
                    <b-form-group>
                        <label for="extraEquipment">Extrautrustning
                        </label>
                        <b-form-input type="text" id="extraEquipment"
                            v-model.number="$v.benefitCalculationValues.extraEquipment.$model"
                            class="col-lg-2 col-md-3 col-sm-9 col-12"
                            :class="{ 'is-invalid': $v.benefitCalculationValues.extraEquipment.$anyError}">
                        </b-form-input>
                        <b-form-invalid-feedback>
                            Ogiltigt eller saknat obligatoriskt värde
                        </b-form-invalid-feedback> 
                    </b-form-group>
                    <button class="btn btn-primary mt-1 mb-2" v-on:click="showAutofillBenefitValueDialogue()" :disabled="calculating" v-if="loginState.isAdministrator" >
                        <b-spinner v-if="calculating" class="mr-1" type="border" small />Beräkna förmånsvärde
                    </button>
                    <table class="w-25">
                        <thead>
                            <tr>
                                <th class="w-25">År</th>
                                <th class="w-25">Förmånsvärde</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(benefitVehicleBenefit, index) in benefitVehicle.benefitVehicleBenefits" :key="benefitVehicleBenefit.year">
                                <td>{{benefitVehicleBenefit.year}}</td>
                                <td>
                                    <b-form-input type="text"
                                        :disabled="isYearExpired(benefitVehicleBenefit.year)"
                                        v-model.number="benefitVehicleBenefit.value"
                                        :class="{ 'is-invalid': $v.benefitVehicle.benefitVehicleBenefits.$each[index].value.$anyError}">
                                    </b-form-input>
                                    <b-form-invalid-feedback>
                                        Ogiltigt eller saknat obligatoriskt värde
                                    </b-form-invalid-feedback> 
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </b-tab>
            </b-tabs>
            <button class="btn btn-primary mt-1" v-on:click="saveBenefitVehicle()" :disabled="saving" v-if="loginState.isAdministrator" >
                <b-spinner v-if="saving" class="mr-1" type="border" small />{{saving ? 'Sparar' : 'Spara'}}
            </button>

        </b-card>
    </div>
</template>

<script>
import { employeeService } from "../../shared/services";
import { benefitVehicleService } from "../../shared/services/benefitVehicle.service"
import { required, numeric, decimal } from 'vuelidate/lib/validators'

export default {
  created() {
    this.loginState.init();
  }, 
  computed: {
    sortedBenefitVehicles() {
      if(!this.benefitVehicles) return [];
      return this.benefitVehicles.filter(f => f.isActive || this.showInactiveBenefitVehicles);
    }
  },    
  data() {
    return {
      loading: false,
      saving: false,
      calculating: false,
      benefitVehicle: {
          isActive: false,
          employeeId: null,
          vehicleType: null,
          registrationNumber: null,
          modelCode: null,
          model: null,
          brand: null,
          productionYear: null,
          fuelType: null,
          price: null,
          adjustmentPrice: null,
          benefitVehicleBenefits: []
      },
      benefitCalculationValues: {
          distanceOverThreeThousand: false,
          vehicleTax: null,
          extraEquipment: null,
      },
      employees: [],
      vehicleTypes: [
        { id: 10, name: "Personbil" },
        { id: 20, name: "Cykel" },
      ],
      fuelTypes: [
        { id: 10, name: "Ingen" },
        { id: 20, name: "Diesel" },
        { id: 30, name: "Bensin" },
        { id: 40, name: "Gas" },
        { id: 50, name: "Alkohol" },
        { id: 60, name: "Elhybrid" },
      ],
    };
  },
  validations: {
    benefitVehicle: {
      employeeId: {
        required
      },
      vehicleType: {
        required
      },
      registrationNumber: {
        required
      },
      modelCode: {
        required
      },
      model: {
        required
      },
      brand: {
        required
      },
      productionYear: {
        required,
        numeric
      },
      fuelType: {
        required
      },
      price: {
        required,
        decimal
      },
      adjustmentPrice: {
        required,
        decimal
      },
      benefitVehicleBenefits: {
          $each: {
              value: {
                  required,
                  decimal
              }
          }
      },
    },
    validationGroup_Information: [
        'benefitVehicle.employeeId', 
        'benefitVehicle.vehicleType', 
        'benefitVehicle.registrationNumber',
        'benefitVehicle.modelCode',
        'benefitVehicle.model',
        'benefitVehicle.brand',
        'benefitVehicle.productionYear',
        'benefitVehicle.fuelType',
        'benefitVehicle.price',
        'benefitVehicle.adjustmentPrice',
    ],
    validationGroup_Benefits: [
        'benefitVehicle.benefitVehicleBenefits', 
    ],
    benefitCalculationValues: {
          vehicleTax: {
              required,
              decimal
          },
          extraEquipment: {
              required,
              decimal
          }
      }
  }, 
  async mounted() {
    await this.getVehicle();
  },
  methods: {
    async getVehicle() {
      this.loading = true;
      try {
        if (this.$route.params.id != 0){
            this.benefitVehicle = await benefitVehicleService.getByRegistrationNumber(this.$route.params.id);
        }
        this.employees = await employeeService.get();

        var today = new Date();
        var year = today.getFullYear();
        if(!this.benefitVehicle.benefitVehicleBenefits.filter(benefit => benefit.year == year).length > 0){
            var benefitVehicleBenefit = {
                year: year,
                value: 0
            };
            this.benefitVehicle.benefitVehicleBenefits.push(benefitVehicleBenefit);
        }
      } catch {
        this.ShowToast("Fel", "Ett okänt fel uppstod då fordon skulle hämtas", "danger")
      }
      this.loading = false;
    },
    getVehicleTypeName(id) {
      var vehicles = this.vehicleTypes.filter(v => v.id == id);
      if (vehicles.length === 0) return "Okänd fordonstyp"
      return vehicles[0].name;
    },
    getFuelTypeName(id) {
      var fuels = this.fuelTypes.filter(v => v.id == id);
      if (fuels.length === 0) return "Okänd bränsletyp"
      return fuels[0].name;
    },
    getVehicleTypeId(name) {
      var vehicles = this.vehicleTypes.filter(v => v.name == name);
      if (vehicles.length === 0) return null
      return vehicles[0].id;
    },
    getFuelTypeId(name) {
      var fuels = this.fuelTypes.filter(v => v.name == name);
      if (fuels.length === 0) return null
      return fuels[0].id;
    },
    getEmployeeName(id) {
      var employee = this.employees.filter(v => v.id == id)[0];
      if (!employee) return "Laddar..."
      return employee.firstName + " " + employee.lastName;
    },
    employeeSelected(employee){
        this.benefitVehicle.employeeId = employee.id;
    },
    vehicleTypeSelected(vehicleType){
        this.benefitVehicle.vehicleType = vehicleType.id;
    },
    fuelTypeSelected(fuelType){
        this.benefitVehicle.fuelType = fuelType.id;
    },
    async showAutofillDialogue(){
        this.$bvModal.msgBoxConfirm(`Vill du få resterande fordonsinformation ifylld automatiskt?`).then(async p => {
            if(!p) return;
            try{
                var data = await benefitVehicleService.getVehicleInformationByModelCode(this.benefitVehicle.modelCode);
                var result = data.results[0];
                if(!result){
                    this.ShowToast("Ingen data", "Ingen data hittades för modellkod \"" + this.benefitVehicle.modelCode + "\"", "info")
                } else{
                    this.benefitVehicle.adjustmentPrice = result.justering ? parseInt(result.justering) : null;
                    this.benefitVehicle.brand = result.marke;
                    this.benefitVehicle.model = result.modell;
                    this.benefitVehicle.price = result.nybilspris ? parseInt(result.nybilspris) : null;
                    this.benefitVehicle.productionYear = result.tillverkningsar ? parseInt(result.tillverkningsar) : null;
                    this.benefitVehicle.fuelType = this.getFuelTypeId(result.bransletyp) ? this.getFuelTypeId(result.bransletyp) : this.benefitVehicle.fuelType;
                    this.benefitVehicle.vehicleType = this.getVehicleTypeId(result.fordonstyp) ? this.getVehicleTypeId(result.fordonstyp) : this.benefitVehicle.vehicleType;
                }
            } catch{
                this.ShowToast("Fel", "Ett okänt fel uppstod då fordonsinformation skulle hämtas", "danger")
            }
        });
    },
    async showAutofillBenefitValueDialogue(){
        this.$v.benefitCalculationValues.$touch();
        this.$v.benefitVehicle.modelCode.$touch();
        if(this.$v.benefitCalculationValues.$anyError || this.$v.benefitVehicle.modelCode.$anyError) return;

        this.calculating = true;
        var newCarPrice = this.benefitVehicle.price + this.benefitVehicle.adjustmentPrice;
        var benefitValue = await benefitVehicleService.calculateBenefitValue(this.benefitCalculationValues, newCarPrice);
        this.calculating = false;

        var today = new Date();
        var currentYear = today.getFullYear();
        this.$bvModal.msgBoxConfirm(`Förmånsvärdet beräknas till ` + benefitValue + `kr/år och ` + benefitValue/12 + `kr/månad vill du fylla i detta automatiskt för år ` + currentYear + `?`).then(async p => {
            if(!p) return;
            if(this.benefitVehicle.benefitVehicleBenefits.filter(b => b.year == currentYear).length > 0){
                this.benefitVehicle.benefitVehicleBenefits.filter(b => b.year == currentYear)[0].value = benefitValue;
            } else{
                var benefitVehicleBenefit = {
                    year: currentYear,
                    value: benefitValue
                }
                this.benefitVehicle.benefitVehicleBenefits.push(benefitVehicleBenefit);
            }
        });

    },
    isYearExpired(year){
        var today = new Date();
        var currentYear = today.getFullYear();
        return year <= currentYear-2;
    },
    formatToUpperCase(value){
        return value.toUpperCase();
    },
    async saveBenefitVehicle(){
        this.$v.benefitVehicle.$touch();
        if(this.$v.benefitVehicle.$anyError) return;

        this.saving = true;
        try {
            await benefitVehicleService.save(this.benefitVehicle);
            this.ShowToast("Sparad", "Fordonsinformationen sparades", "success");
            this.$router.push({
                path: "/administration/benefitVehicles"
            });
        } catch {
            this.ShowToast("Fel", "Ett okänt fel uppstod då fordon skulle sparas", "danger")
        }
        this.saving = false;
    }
  }
}
</script>

<style>

</style>
